import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import UserControls from 'flarum/forum/utils/UserControls';
import Button from 'flarum/common/components/Button';
import extractText from 'flarum/common/utils/extractText';
export default function () {
  extend(UserControls, 'userControls', function (items) {
    const user = arguments[1];
    if (app.session.user === user || !app.session.user || !user.canBeIgnored()) {
      return;
    }
    function unignore() {
      if (confirm(extractText(app.translator.trans("fof-ignore-users.forum.user_controls.unignore_confirmation")))) {
        this.save({
          ignored: false
        });
      }
    }
    function ignore() {
      if (confirm(extractText(app.translator.trans("fof-ignore-users.forum.user_controls.ignore_confirmation")))) {
        this.save({
          ignored: true
        });
      }
    }
    if (user.ignored()) {
      items.add('unignore', m(Button, {
        icon: "fas fa-comment",
        onclick: unignore.bind(user)
      }, app.translator.trans('fof-ignore-users.forum.user_controls.unignore_button')));
    } else {
      items.add('ignore', m(Button, {
        icon: "fas fa-comment-slash",
        onclick: ignore.bind(user)
      }, app.translator.trans('fof-ignore-users.forum.user_controls.ignore_button')));
    }
  });
}